/*!
 * Platform Switch —— 平台切換器（v2.39.0 改成 segmented control）
 *
 * 顯示在側欄最上面，讓用戶在 OA 和 Tiny 之間切換。
 * 原本是一張「選擇平台」卡片裝兩顆大按鈕，佔側欄約 90px；
 * 現在是一條分段開關：每段是平台自己的 logo（PLATFORM_INFO.logo，原圖不加工）
 * + 短名（OA / TiNY），選中的那段浮起來。側欄寬度有限，全名會被截斷，所以用短名。
 * logo 與名稱一律取自 PLATFORM_INFO，這裡不寫死。
 */
import React from "react";
import { usePlatform, PLATFORM_INFO } from "contexts/PlatformContext";
import "./PlatformSwitch.css";

function PlatformSwitch() {
  const { currentPlatform, switchPlatform } = usePlatform();

  return (
    <div className="platform-switch" role="group" aria-label="平台">
      <div className="platform-switch-caption">平台</div>
      <div className="platform-switch-seg">
        {Object.entries(PLATFORM_INFO).map(([key, info]) => {
          const isActive = currentPlatform === key;
          return (
            <button
              key={key}
              type="button"
              className={`platform-switch-opt${isActive ? " is-active" : ""}`}
              onClick={() => switchPlatform(key)}
              aria-pressed={isActive}
              title={info.name}
            >
              {info.logo
                ? <img src={info.logo} alt="" className="platform-switch-logo" />
                : <i className={info.icon} aria-hidden="true" />}
              <span className="platform-switch-name">{info.shortName}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default PlatformSwitch;
